// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ZQox","title":"Header_title__3jw9D","side":"Header_side__2Tt2E"};